exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-padding[data-v-4071dd23]{padding-left:10%}.position-no[data-v-4071dd23]{position:absolute;top:0;right:0;z-index:-1}td[data-v-4071dd23],th[data-v-4071dd23]{text-align:center!important;width:295px;max-width:295px;min-width:295px}[data-v-4071dd23] .v-datatable.v-table>tbody{max-height:none!important;min-height:0!important}", ""]);

// exports
